module.exports = __webpack_public_path__ + "static/media/YF26_1.59eb5610.jpg";